import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const AnnualLiveBirths = () => {
    const { chartData } = useResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual dos Nascidos Vivos'}
            horizontal={false}
            subtitles={chartData?.annualLiveBirths?.map((item) => item.description)}
            values={chartData?.annualLiveBirths?.map((item) => item.total  ||  0)}
        />
    );
};
